import { BaseApiModel } from './BaseApiModel';

export class LotGeneration extends BaseApiModel {
  namePattern?: string;
  pathPattern?: string;
  pathPatternImport?: string;
  stopAttribution?: boolean;
  lotControlId?: number;
  autoGeneration: Array<{
    lotControlId?: number;
    generationLimit?: number;
    namePattern?: string;
    pathPattern?: string;
    pathPatternImport?: string;
    period?: number;
    cron?: string;
    maxAmountViolation?: number;
    regulationIds?: Array<number>;
    laneIds?: Array<number>;
    reasonIds?: Array<number>;
    violationStatus?: string[];
    isNotProcessable?: boolean;
    isSpecial?: boolean;
    oddSpeed?: boolean;
    exportOriginalFiles?: boolean;
    violationSourceId?: number;
  }>;
}
